<script setup lang="ts">
import { ref } from 'vue'

import { storeToRefs } from 'pinia'

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { useTimeout } from '@/composables/useTimeout'
import { useFlowStore } from '@/stores/flowStore'

const flowStore = useFlowStore()
const { flow } = storeToRefs(flowStore)

const { set, clear } = useTimeout()

const isPopoverOpen = ref<boolean>(false)

const openPopover = (): void => {
  clear()
  isPopoverOpen.value = true
}

const scheduleClosePopover = (): void => {
  set(() => {
    isPopoverOpen.value = false
  }, 120)
}
</script>

<template>
  <Popover v-model:open="isPopoverOpen">
    <PopoverTrigger as-child>
      <button
        type="button"
        class="max-w-xl cursor-pointer truncate border-0 bg-transparent p-0 text-left text-inherit outline-none focus:outline-none focus-visible:outline-none"
        @mouseenter="openPopover"
        @mouseleave="scheduleClosePopover"
      >
        {{ flow?.name }}
      </button>
    </PopoverTrigger>
    <PopoverContent
      side="bottom"
      :side-offset="2"
      class="w-auto max-w-2xl border bg-white px-2 py-0"
      @mouseenter="openPopover"
      @mouseleave="scheduleClosePopover"
    >
      <div v-if="flow" class="flex max-w-2xl flex-col gap-y-0.5 p-2 text-sm">
        <div>
          <h4 class="font-bold">
            {{ $t('flow.manage.productType') }}
          </h4>
          <span class="text-muted-foreground">
            {{ flow.productType.name }}
          </span>
        </div>
        <div v-if="flow.productSubtype">
          <h4 class="font-bold">
            {{ $t('flow.manage.productSubtype') }}
          </h4>
          <span class="text-muted-foreground">
            {{ flow.productSubtype?.name }}
          </span>
        </div>
        <div v-if="flow.productBrand">
          <h4 class="font-bold">
            {{ $t('flow.manage.productBrand') }}
          </h4>
          <span class="text-muted-foreground">
            {{ flow.productBrand?.name }}
          </span>
        </div>
        <div v-if="flow.productModel">
          <h4 class="font-bold">
            {{ $t('flow.manage.productModel') }}
          </h4>
          <span class="text-muted-foreground">
            {{ flow.productModel.name }}
          </span>
        </div>
        <div>
          <h4 class="font-bold">
            {{ $t('flow.manage.version') }}
          </h4>
          <span class="text-muted-foreground">
            {{ flow.version }}
          </span>
        </div>
        <div>
          <h4 class="font-bold">
            {{ $t('flow.manage.name') }}
          </h4>
          <span class="text-muted-foreground">
            {{ flow.name }}
          </span>
        </div>
        <div>
          <h4 class="font-bold">
            {{ $t('flow.manage.code') }}
          </h4>
          <span class="text-muted-foreground">
            {{ flow.code }}
          </span>
        </div>
        <div>
          <h4 class="font-bold">
            {{ $t('flow.manage.createdBy') }}
          </h4>
          <span class="text-muted-foreground">
            {{ `${flow.createdBy.firstName} ${flow.createdBy.lastName}` }}
          </span>
        </div>
      </div>
    </PopoverContent>
  </Popover>
</template>
